export default "__VITE_ASSET__473b89a0__"